// extracted by css-extract-rspack-plugin
export default {"editorContainer":"beefree-editor__editorContainer___nUEqi"};